import genericState from "@/store/generic/state";

import state from "@/store/item/state";
import mutations from "@/store/item/mutations";
import actions from "@/store/item/actions";

export default {
  state() {
    return {
      ...genericState(),
      ...state,
    };
  },
  mutations: {
    ...mutations,
  },
  actions,
};
